import React, { useContext } from "react";
import { GlobalContext } from "../context/Store";
import { motion } from "framer-motion";

const SingleSkill = ({ image, skillName, tools, animateDelay }) => {
  // ✅ States / Variables ------------------------------------------------------------------------------------------------------------
  const { imgAnimationCustom } = useContext(GlobalContext);
  
  return (
    <motion.div
      {...imgAnimationCustom(0.1, animateDelay)}
      key={Math.random()}
      className="flex flex-col items-center gap-2 rounded-lg bg-secondary-color pt-3 font-open-sans-font text-xl font-bold text-white shadow-primary-shadow transition-all duration-300 hover:-translate-y-[2px] md:w-60"
      style={{ width: "17rem", height: "25rem" }}
    >
      <div className="h-3/4">
        <img className="h-sm" src={image} alt="Skill" />
      </div>
      <div className="flex flex-col items-center justify-center h-1/4 mb-52 mt-24">
        <div className="border-2 border-black p-2 rounded-md mb-2">
          <p className="text-base">{skillName}</p>
        </div>
        <div className="text-base text-zinc-850 mt-2 text-black  border-white p-2 rounded-md mb-4 bg-blue-100">Tools I Use</div>
        <div className="border-2 border-white p-3 rounded-lg h-40 w-36 pl-9 ">
          <ul className="text-sm text-white mb-11 mt-5"  style={{ marginTop: "-0.3rem" }}>
            {Array.isArray(tools) ? (
              tools.map((tool, index) => (
                <li key={index} className="mb-1">
                  {tool}
                </li>
              ))
            ) : (
              <li>{tools}</li>
            )}
          </ul>
        </div>
      </div>
    </motion.div>
  );
};

export default SingleSkill;
